import { businessKey } from 'queryKeys';

const PARENT_CAMPAIGNS = 'parentCampaigns';

const MUTATION_EXPORT = 'export';

const query = businessKey.query(PARENT_CAMPAIGNS);

export const grids = query.grids();
export const grid = query.grid();
export const exact = query.exact();

export const details = query.details();
export const mutations = query.mutations();

export const create = mutations.create();
export const update = mutations.update();

export const exportParentCampaigns = mutations.mutate(MUTATION_EXPORT);
